'use strict';
import register from './core';
import '../functions/jquery-global.js';
import { trackLink } from '../functions/common';

register('button-ripple', function (element) {
  let $el = $(element),
    $link = $el.find('a.button.js-track-link'),
    $buttons = $el.find('.button'),
    $shareButtons = $el.find('.share-button');
  $buttons.on('click', function (e) {
    $(this).find('.ripple').remove();

    var posX = $(this).offset().left,
      posY = $(this).offset().top,
      buttonWidth = $(this).width(),
      buttonHeight = $(this).height();

    $(this).prepend('<span class="ripple"></span>');

    if (buttonWidth >= buttonHeight) {
      buttonHeight = buttonWidth;
    } else {
      buttonWidth = buttonHeight;
    }

    var x = e.pageX - posX - buttonWidth / 2;
    var y = e.pageY - posY - buttonHeight / 2;

    $(this).find('.ripple').css({
      width: buttonWidth,
      height: buttonHeight,
      top: y + 'px',
      left: x + 'px'
    }).addClass('ripple-effect');

    $(this).find('ripple-effect')
      .one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
        function () {
          $(this).find('.ripple').remove();
        });
  });
  $shareButtons.on('click', function (e) {
    var label = $(this).text().trim();
    trackLink('sz', 'CTA', 'Click', label);
  });

  $link.on('click', function (e) {
    var label = $(this).text();
    trackLink('sz', 'CTA', 'Click', label);
  });
});
